import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {Berth, ExemptionReferenceData, Municipality} from '@portbase/bezoekschip-service-typescriptmodels';
import {sendQuery} from '../../common/utils';

@Component({
    selector: 'app-edit-exemption',
    templateUrl: './edit-exemption.component.html',
    styleUrls: ['./edit-exemption.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditExemptionComponent {

  @Input() exemptionInfo: ExemptionReferenceData;

  allMunicipalities: Municipality[] = [
    {code: "NLABL", name: "Alblasserdam"},
    {code: "NLDOR", name: "Dordrecht"},
    {code: "NLGDR", name: "Goedereede"},
    {code: "NLGOR", name: "Gorinchem"},
    {code: "NLHXG", name: "Hardinxveld-Giessendam"},
    {code: "NLMSL", name: "Maassluis"},
    {code: "NLMOE", name: "Moerdijk"},
    {code: "NLNIJ", name: "Nijmegen"},
    {code: "NLPAP", name: "Papendrecht"},
    {code: "NLRTM", name: "Rotterdam"},
    {code: "NLSCI", name: "Schiedam"},
    {code: "NLSLD", name: "Sliedrecht"},
    {code: "NLSTD", name: "Stellendam"},
    {code: "NLVLA", name: "Vlaardingen"},
    {code: "NLZWI", name: "Zwijndrecht"}
  ]

  exemptionTypes : string[] = [
    "Exemption General",
    "Exemption Debunkering",
    "Exemption ISPS",
    "Exemption Oude Maas",
    "Exemption Tijpoort",
    "Exemption 3.2",
    "Exemption 3.4",
    "Exemption 3.5",
    "Exemption 3.6",
    "Exemption 3.11",
    "Exemption 3.13",
    "Exemption 4.1",
    "Exemption 4.5",
    "Exemption 4.6",
    "Exemption 4.11",
    "Exemption 4.11b",
    "Exemption 4.13 (1)",
    "Exemption 4.13 (2)",
    "Exemption 5.2",
    "Exemption 5.3",
    "Exemption 5.4, 5.5, 5.6",
    "Exemption 5.4, 5.6, 5.7",
    "Exemption 6.3.1",
    "Exemption 6.3.3, 6.3.4",
    "Exemption 6.3.5",
    "Exemption 6.4",
    "Exemption 6.5",
    "Exemption 7.1 lid 1",
    "Exemption 7.1 lid 2",
    "Exemption 8.1",
  ]

  berthSearchFunction = term => {
    return sendQuery('com.portbase.bezoekschip.common.api.visit.FindBerthsAndBuoys', {term: term},
      {caching: false});
  }

  berthFormatter = (value: Berth) => value.name + ' – ' + value.code +
                                      (value.bollards ? ' (' + value.bollards.start + '-' + value.bollards.end	 + ')': '');

  municipalitiesHaveTheSameCode(first: Municipality, second: Municipality): boolean {
    return first?.code == second?.code;
  }

  formatMunicipality(municipality) : string {
    return municipality.name;
  }

  get municipalityNotSelected(): boolean {
    return this.exemptionInfo.applicableMunicipalities == null || this.exemptionInfo.applicableMunicipalities.length == 0;
  }
}
